import { combineReducers } from "redux";
import {
    PaymentDataReducer,
    PaymentLinkReducer,
    ConfirmClaimCodeReducer,
    BankListReducer,
    ResolveBankReducer,
    ClaimPayoutReducer,
    VasServicesReducer,
    VasCategoriesReducer,
    VasProductsReducer,
    VerifyVasEntityReducer
} from './payment';

const rootReducer = combineReducers({
    paymentData: PaymentDataReducer,
    paymentLink: PaymentLinkReducer,
    confirmClaimCode: ConfirmClaimCodeReducer,
    bankList: BankListReducer,
    resolveBank: ResolveBankReducer,
    claimPayout: ClaimPayoutReducer,
    vasServices: VasServicesReducer,
    vasCategories: VasCategoriesReducer,
    vasProducts: VasProductsReducer,
    verifyVasEntity: VerifyVasEntityReducer
});

export default rootReducer;
